import { render } from "./WrapperLayout.vue?vue&type=template&id=78e09d6c"
import script from "./WrapperLayout.vue?vue&type=script&lang=ts"
export * from "./WrapperLayout.vue?vue&type=script&lang=ts"
script.render = render

export default script